import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpJobOrderHdrContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-hdr-container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class MrpCreateProcessInstanceService extends BaseApiTemplateService<MrpJobOrderHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"
    this.httpClient = http;
  }

  public createJobInstancesByGuid(jobOrderGuid: string,dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/create-instances/backoffice-ep/'+ jobOrderGuid;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
